const formPatient = {
  // rhythm,
  // frequency,
  // cycle,
  // axis,
  // corner,
  // waveP,
  // distancePR,
  // QRS,
  // waveT,
  // ST,
  // distanceST,
  // distanceQT,
  // conclude,
  // diagnosis,
  // result,

  // nhịp điệu,
  // tần số,
  // chu kỳ,
  // trục,
  // góc,
  // sóngP,
  // khoảng cách PR,
  // QRS,
  // sóngT,
  // ST,
  // khoảng cách ST,
  // khoảng cách QT,
  // kết luận,
  // chẩn đoán,
  // kết quả

  formId: "new-patient-form",
  formField: {
    rhythm: {
      name: "rhythm",
      label: "Nhịp",
      type: "text",
      placeholder: "rhythm",
      errorMsg: "Không được bỏ trống.",
    },
    frequency: {
      name: "frequency",
      label: "Tần số",
      type: "text",
      placeholder: "frequency",
      errorMsg: "Không được bỏ trống.",
    },
    cycle: {
      name: "cycle",
      label: "Chu kỳ",
      type: "text",
      placeholder: "cycle",
      errorMsg: "Không được bỏ trống.",
    },
    axis: {
      name: "axis",
      label: "Trục",
      type: "text",
      placeholder: "axis",
      errorMsg: "Không được bỏ trống.",
    },
    corner: {
      name: "corner",
      label: "Góc",
      type: "text",
      placeholder: "corner",
      errorMsg: "Không được bỏ trống.",
    },
    waveP: {
      name: "waveP",
      label: "Sóng P",
      type: "text",
      placeholder: "waveP",
      errorMsg: "Không được bỏ trống.",
    },
    distancePR: {
      name: "distancePR",
      label: "khoảng cách PR",
      type: "text",
      placeholder: "distancePR",
      errorMsg: "Không được bỏ trống.",
    },
    QRS: {
      name: "QRS",
      label: "QRS",
      type: "text",
      placeholder: "QRS",
      errorMsg: "Không được bỏ trống.",
    },
    waveT: {
      name: "waveT",
      label: "Sóng T",
      type: "text",
      placeholder: "waveT",
      errorMsg: "Không được bỏ trống.",
    },
    ST: {
      name: "ST",
      label: "ST",
      type: "text",
      placeholder: "ST",
      errorMsg: "Không được bỏ trống.",
    },
    distanceST: {
      name: "distanceST",
      label: "Khoảng cách ST",
      type: "text",
      placeholder: "distanceST",
      errorMsg: "Không được bỏ trống.",
    },
    distanceQT: {
      name: "distanceQT",
      label: "Khoảng cách QT",
      type: "text",
      placeholder: "distanceQT",
      errorMsg: "Không được bỏ trống.",
    },
    conclude: {
      name: "conclude",
      label: "Kết luận",
      type: "text",
      placeholder: "conclude",
      errorMsg: "Không được bỏ trống.",
    },
    diagnosis: {
      name: "diagnosis",
      label: "Chuẩn đoán",
      type: "text",
      placeholder: "diagnosis",
      errorMsg: "Không được bỏ trống.",
    },
    result: {
      name: "result",
      label: "Kết quả",
      type: "text",
      placeholder: "result",
      errorMsg: "Không được bỏ trống.",
    },
  },
};

export default formPatient;
